import { Button, DatePicker, Input, Space, type InputProps } from "antd";
import type { ColumnsType } from "antd/es/table";
import { Key } from "react";
import { DateHelper } from "./DateHelper";
import { FontFa } from "../components";
import moment from "moment";

interface SearchTextColumnParams {
  inputSearchProps?: InputProps;
  searchBtnText?: string;
  resetBtnText?: string;
  dataIndex: string;
}

interface SearchCalendarColumnParams {
  inputSearchProps?: InputProps;
  searchBtnText?: string;
  resetBtnText?: string;
  dataIndex: string;
}

const { RangePicker } = DatePicker;

export const TableHelpers = {
  searchInput<T extends any>(params: SearchTextColumnParams): ColumnsType<T>[number] {
    return {
      filterDropdown({ setSelectedKeys, selectedKeys, confirm, clearFilters }) {
        return (
          <div className="flex flex-col p-2 gap-1">
            <Input
              {...params.inputSearchProps}
              className="font-normal"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() => confirm()}
            />
            <Space style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  if (clearFilters) clearFilters();
                }}
                type="text"
                size="small"
              >
                {params.resetBtnText ?? "Reset"}
              </Button>
              <Button onClick={() => confirm()} type="primary" size="small">
                {params.searchBtnText ?? "Tìm"}
              </Button>
            </Space>
          </div>
        );
      },
      filterIcon: (filtered: boolean) => <FontFa name="faSearch" size="1x" color="#333" />,
      onFilter: (searchValue: boolean | Key, record: any) => {
        if (!searchValue) return true;
        const recordValue: string = record[params.dataIndex];
        return recordValue?.toLowerCase()?.includes((searchValue as string)?.toLowerCase());
      },
    };
  },
  searchRangePicker<T extends any>(params: SearchCalendarColumnParams): ColumnsType<T>[number] {
    return {
      filterDropdown({ setSelectedKeys, selectedKeys, confirm, clearFilters }) {
        const rangeDateValue: any = selectedKeys[0]
          ? DateHelper.rangeDateStringifyToMoment(selectedKeys[0].toString())
          : [];
        return (
          <div className="flex flex-col gap-1 p-2">
            <RangePicker
              value={rangeDateValue}
              onChange={(dates) => setSelectedKeys(dates ? [JSON.stringify(dates)] : [])}
              placeholder={["Từ ngày", "Đến ngày"]}
            />
            <Space style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  if (clearFilters) clearFilters();
                }}
                type="text"
                size="small"
              >
                {params.resetBtnText ?? "Reset"}
              </Button>
              <Button onClick={() => confirm()} type="primary" size="small">
                {params.searchBtnText ?? "Tìm"}
              </Button>
            </Space>
          </div>
        );
      },
      filterIcon: (filtered: boolean) => <FontFa name="faCalendar" size="1x" color={filtered ? "#007aff" : "#333"} />,
      onFilter: (s: boolean | Key, record: any) => {
        const rangeDate = DateHelper.rangeDateStringifyToMoment(s as string);
        if (!rangeDate) return true;
        const value = moment(record[params.dataIndex]);
        return value.isBetween(rangeDate[0].clone().startOf("days"), rangeDate[1].clone().endOf("days"));
      },
    };
  },
};
